import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Router} from '@angular/router';
import {DocumentService} from '../services/document-service';
import {PersonLoginService} from '../services/person-login-service';
import {FileUtils} from '../utils/file-utils';
import {StringUtils} from '../utils/string-utils';

interface ReportOption {
  code: string;
  description: string;
}

@Component({
  selector: 'reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule]
})
export class ReportsComponent implements OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly documentService = inject(DocumentService);
  private readonly router = inject(Router);

  public reports: ReportOption[] = [
    {code: 'openSpecialQuoteRequests', description: 'Open Special Quote Requests'},
    {code: 'todaysApprovedQuotes', description: "Today's Approved Quotes"},
    {code: 'repOfficeRoster', description: 'Rep Office Roster'}
  ];
  public selectedReportCode!: string;
  public readonly running = signal<boolean>(false);
  public readonly errorMessage = signal<string>(undefined!);

  ngOnInit(): void {
    if (!this.personLoginService.isInternal()) {
      this.router.navigate(['unauthorized']);
    }
  }

  public runReport(): void {
    this.errorMessage.set(null!);
    if (!this.selectedReportCode) {
      return;
    }
    this.running.set(true);
    switch (this.selectedReportCode) {
      case 'openSpecialQuoteRequests':
        this.downloadOpenSpecialQuoteRequests();
        break;
      case 'todaysApprovedQuotes':
        this.downloadTodaysApprovedQuotes();
        break;
      case 'repOfficeRoster':
        this.downloadRepOfficeRoster();
        break;
      default:
        this.running.set(false);
    }
  }

  private downloadOpenSpecialQuoteRequests(): void {
    this.documentService.getOpenSpecialQuoteRequestsReport().subscribe({
      next: (blob: Blob) => {
        FileUtils.downloadFile(blob, 'OpenSpecialQuoteRequests.xlsx');
        this.running.set(false);
      },
      error: (error) => {
        this.errorMessage.set(StringUtils.getErrorMessage(error));
        this.running.set(false);
      }
    });
  }

  private downloadTodaysApprovedQuotes(): void {
    this.documentService.getTodaysApprovedQuotesReport().subscribe({
      next: (blob: Blob) => {
        FileUtils.downloadFile(blob, 'TodaysApprovedQuotes.xlsx');
        this.running.set(false);
      },
      error: (error) => {
        this.errorMessage.set(StringUtils.getErrorMessage(error));
        this.running.set(false);
      }
    });
  }

  private downloadRepOfficeRoster(): void {
    this.documentService.getRepOfficeRosterReport().subscribe({
      next: (blob: Blob) => {
        FileUtils.downloadFile(blob, 'RepOfficeRoster.xlsx');
        this.running.set(false);
      },
      error: (error) => {
        this.errorMessage.set(StringUtils.getErrorMessage(error));
        this.running.set(false);
      }
    });
  }
}
